import React from 'react';
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio as MuiRadio,
  RadioGroup,
} from '@mui/material';
import { ErrorMessage, showErrorOnChange, useFieldForErrors } from './Util';
import { Field } from 'react-final-form';

const Radio = (props) => {
  const {
    name,
    data,
    dataKey,
    dataValue,
    label,
    required,
    helperText,
    formLabelProps,
    formControlLabelProps,
    fieldProps,
    formControlProps,
    radioGroupProps,
    formHelperTextProps,
    showError = showErrorOnChange,
    ...restRadios
  } = props;
  const field = useFieldForErrors(name);
  const isError = showError(field);

  console.log('props', props);

  return (
    <FormControl required={required} error={isError} {...formControlProps}>
      {!!label && <FormLabel {...formLabelProps}>{label}</FormLabel>}
      <RadioGroup {...radioGroupProps}>
        {data?.map((item, idx) => {
          return (
            <FormControlLabel
              key={idx}
              name={name}
              label={item[dataValue]}
              value={item[dataKey]}
              disabled={item.disabled}
              control={
                <Field
                  name={name}
                  type="radio"
                  render={({
                    input: { name, value, onChange, checked, ...restInput },
                  }) => {
                    // input.onChange = restRadios.onChange;
                    // console.log("name", name);
                    // console.log("value", value, typeof value);
                    // console.log("checked", checked);
                    return (
                      <MuiRadio
                        name={name}
                        value={value}
                        onChange={onChange}
                        checked={checked}
                        disabled={item.disabled}
                        required={required}
                        inputProps={{ required, ...restInput }}
                        {...restRadios}
                      />
                    );
                  }}
                  {...fieldProps}
                />
              }
              {...formControlLabelProps}
            />
          );
        })}
      </RadioGroup>
      <ErrorMessage
        showError={isError}
        meta={field.meta}
        formHelperTextProps={formHelperTextProps}
        helperText={helperText}
      />
    </FormControl>
  );
};

export default Radio;
